import { BrowserProvider } from 'ethers';
import { getReadProvider, getWriteProvider, TChainId } from 'modules/api';

export class VaultProvider extends BrowserProvider {
  private static readInstance: VaultProvider;
  private static writeInstance: VaultProvider;

  static async getWriteInstance(
    shouldReinitialize?: boolean,
  ): Promise<VaultProvider> {
    if (!VaultProvider.writeInstance || shouldReinitialize) {
      const provider = await getWriteProvider();

      const eip1193Provider = provider.getEIP1193Provider();
      VaultProvider.writeInstance = new BrowserProvider(eip1193Provider);
    }

    return VaultProvider.writeInstance;
  }

  static async getReadInstance(
    shouldReinitialize: boolean,
    chainId: TChainId,
  ): Promise<VaultProvider> {
    if (!VaultProvider.readInstance || shouldReinitialize) {
      const provider = await getReadProvider(chainId);

      const eip1193Provider = provider.getEIP1193Provider();
      VaultProvider.readInstance = new BrowserProvider(eip1193Provider);
    }

    return VaultProvider.readInstance;
  }
}
